import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { CmsComponentTypeEnum, MediaTypesEnum } from '@models/enums';
import { TImageConfig } from '@interfaces/media';

export namespace Media {
  export const TypeEnum = CmsComponentTypeEnum.MEDIA;

  export interface ComponentConfig extends BaseComponentConfig {
    url?: string;
    imageConfig?: TImageConfig;
    youtubeVideoId?: string;
    type: MediaTypesEnum;
    fullWidth?: boolean;
    thumbnailNodeId?: string;
    metas: { title?: string; description?: string };
  }
}
